/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/Content/OrderStatus/Indicator"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Indicator.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1wiWS0': dtColorsNeutral400,'--bc-2-1wiWS0': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}